/** Metadata columns for plot/table-property CSV exports (Studio, Dashboard, Agentic). */
export const PLOT_TABLE_CSV_METADATA_HEADERS = [
  'Sample ID',
  'Asset',
  'Field',
  'Well',
  'Reservoir',
  'Fluid Sample ID',
];

const CAPTION_INDEX = {
  Asset: 0,
  Field: 1,
  Well: 2,
  Reservoir: 3,
  'Fluid Sample ID': 4,
};

const EXCLUDED_DATA_KEYS = new Set([
  'caption',
  '_id',
  'uniqueID',
  'field',
  'asset',
  'well',
  'reservoir',
  'fluidSampleID',
  'FluidSampleID',
]);

function csvEscapeCell(value) {
  const s = value === undefined || value === null ? '' : String(value);
  if (/[",\r\n]/.test(s)) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

function parseCaptionParts(row) {
  if (!row?.caption) return [];
  return String(row.caption).split(',').map((part) => part.trim());
}

function resolveFluidSampleId(row, captionParts) {
  if (captionParts[CAPTION_INDEX['Fluid Sample ID']] !== undefined &&
      captionParts[CAPTION_INDEX['Fluid Sample ID']] !== '') {
    return captionParts[CAPTION_INDEX['Fluid Sample ID']];
  }
  if (row.fluidSampleID != null && row.fluidSampleID !== '') {
    return String(row.fluidSampleID);
  }
  if (row.FluidSampleID != null && row.FluidSampleID !== '') {
    return String(row.FluidSampleID);
  }
  if (row.uniqueID != null && row.uniqueID !== '') {
    return String(row.uniqueID);
  }
  return '';
}

function isExcludedDataKey(key) {
  return EXCLUDED_DATA_KEYS.has(key) || key.endsWith('_decimal');
}

/**
 * Build CSV text for plot downloads from table-property rows.
 * Caption order: Asset, Field, Well, Reservoir, Fluid Sample ID.
 */
export function buildPlotTableCsvContent(data) {
  if (!data?.length) {
    return '';
  }

  const dataHeaders = Object.keys(data[0]).filter((key) => !isExcludedDataKey(key));
  const headers = [...PLOT_TABLE_CSV_METADATA_HEADERS, ...dataHeaders];
  const lines = [headers.map(csvEscapeCell).join(',')];

  for (const row of data) {
    const captionParts = parseCaptionParts(row);
    const values = headers.map((header) => {
      if (header === 'Sample ID') {
        return csvEscapeCell(row._id ?? '');
      }
      if (header in CAPTION_INDEX) {
        if (header === 'Fluid Sample ID') {
          return csvEscapeCell(resolveFluidSampleId(row, captionParts));
        }
        const idx = CAPTION_INDEX[header];
        return csvEscapeCell(captionParts[idx] ?? '');
      }
      return JSON.stringify(row[header], (_key, value) => (value === null ? '' : value));
    });
    lines.push(values.join(','));
  }

  return lines.join('\n');
}
